<template lang="pug">
#base-header
    .view-container
        .base-container(:style='aplicarZindex()')
            .base-title-container
                h1.base__title
                    i.voltar.mdi.mdi-arrow-left-thick(
                        v-if='voltarPara',
                        @click='irParaRota(voltarPara)'
                    )
                    | {{ titulo }}
                .base__breadcrumb(v-if='breadcrumb')
                    el-breadcrumb(separator='.')
                        el-breadcrumb-item(
                            v-for='(sub, index) in breadcrumb',
                            :key='index'
                        )
                            span.link-breadcrumb(@click='irParaRota(sub.rota)')
                                | {{ sub.nome }}
            div.buttons-header
                el-tooltip(v-if="tooltip", placement='bottom')
                    div(slot="content", style="max-width: 200px;text-align: justify;") {{ tooltip }}
                    .base-button-container
                        slot(name='direita')
                        BaseButton.base-button-container__btn(
                            v-if='exibeBotao',
                            type='primary',
                            :icon='icon',
                            :disabled='desabilitaBotao',
                            :loading='loading',
                            @click='emit'
                        )
                            | {{ btnTexto }}
                .base-button-container(v-else)
                    slot(name='direita')
                    BaseButton.base-button-container__btn(
                        type='primary',
                        :icon='icon',
                        v-if='exibeBotao',
                        :disabled='desabilitaBotao',
                        :loading='loading',
                        @click='emit'
                    )
                        | {{ btnTexto }}
                .base-button-container(v-if="exibeBotaoSecundarioAcao")
                    slot(name='direita')
                    el-dropdown
                        BaseButton.base-button-container__btn(
                            type='primary',
                            :icon='iconBotaoSecundario',
                            :loading='loading'
                        )
                            | {{ btnTextoAcoes }}
                        el-dropdown-menu(slot="dropdown", v-if='titulo !== $t("mensagens.operacao.titulo")')
                            el-dropdown-item(
                                v-for='acao in acoes',
                                @click.native='realizarAcao(acao)'
                            ) {{ acao.titulo }}
                        el-dropdown-menu(slot="dropdown", v-else)
                            el-dropdown-item(
                                v-for='acao in acoes',
                                @click.native='realizarAcao(acao)'
                            ) {{ $t(`mensagens.operacao.acoes.${acao.codigo}`) }}
                .base-button-container(v-if="exibeBotaoSecundario")
                    slot(name='direita')
                    el-button.base-button-container__btn(
                        type='primary',
                        :icon='icon',
                        v-if='exibeBotaoSecundario',
                        :disabled='desabilitaBotao',
                        :loading='loading',
                        @click='emitSecundario()'
                    )
                        | {{ btnTextoSecundario }}
</template>

<script>
import BaseButton from '@/components/vegaComponents/BaseButton.vue';
// IMPORTANTE !! Utilize a classe .view-container-base-header para complementar o uso desse componente.
export default {
    name: 'BaseHeader',
    components: {
        BaseButton
    },
    emits: ['btnHeaderClicado', 'btnHeaderClicadoSecundario'],
    props: {
        titulo: {
            type: String,
            default: () => ''
        },
        voltarPara: {
            type: [Object, Boolean, String],
            default: () => null
        },
        breadcrumb: {
            type: Array,
            default: () => []
        },
        acoes: {
            type: Array,
            default: () => []
        },
        btnTexto: {
            type: String,
            default: () => ''
        },
        btnTextoSecundario: {
            type: String,
            default: () => ''
        },
        btnTextoAcoes: {
            type: String,
            default: () => ''
        },
        icon: {
            type: String,
            default: () => ''
        },
        iconBotaoSecundario: {
            type: String,
            default: () => ''
        },
        exibeBotao: {
            type: Boolean,
            default: false
        },
        desabilitaBotao: {
            type: Boolean,
            default: false
        },
        tooltip: {
            type: String,
            default: () => null
        },
        loading: {
            type: Boolean,
            default: false
        },
        exibeBotaoSecundario: {
            type: Boolean,
            default: false
        },
        exibeBotaoSecundarioAcao: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        aplicarZindex () {
            if (this.$route.name === 'operacaoDashboard') {
                return { 'z-index': '3001' };
            }
        },
        irParaRota(rota) {
            if (!rota) return;
            if (typeof rota === 'boolean' && rota) {
                this.$router.go(-1);
            } else if (typeof rota === 'string' && rota === 'emit') {
                this.$emit('voltarClicado');
            } else if (this.$route.name !== rota.route) {
                this.$router.push({ name: rota.route });
            }
        },
        emit() {
            this.$emit('btnHeaderClicado');
        },
        realizarAcao(acao) {
            this.$emit('realizarAcao', acao.emit);
        },
        emitSecundario() {
            this.$emit('btnHeaderClicadoSecundario');
        }
    }
};
</script>

<style lang="scss">
#base-header {
    background: var(--white);
    box-shadow: 0 1px 3px 0 var(--block-shadow);
    .base-container {
        width: 100%;
        min-height: 87px;
        background: var(--white);
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        position: relative;

        .base__title {
            display: flex;
            align-items: center;
            .voltar {
                cursor: pointer;
                font-size: 27px;
                color: #303133;
            }
            .voltar:hover {
                color: var(--secondary);
            }
        }
        .base-title-container {
            display: flex;
            flex-direction: column;
            .base__title {
                font-weight: 600;
            }
            .base__breadcrumb {
                margin-top: 8px;
                span.link-breadcrumb {
                    color: #1989fa;
                    text-decoration: underline;
                    cursor: pointer;
                }
                span.link-breadcrumb:hover {
                    color: var(--secondary);
                }
            }
        }
    }
    .button-outline {
        border-color: var(--secondary-two) !important;
        color: var(--white) !important;
        background: var(--secondary-two) !important;
    }
    .base-button-container__btn {
        span {
            margin-left: 5px;
        }
    }
    .buttons-header {
        width: fit-content;
        display: flex;
        gap: 2%;
    }
}
</style>
